import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 유료 구매 목록 삭제
 *
 * Origin: pageNicolasApi.deleteInvenPaid
 * API: DELETE /api/v1/inven/paid
 */
export async function deleteInvenPaid(
  series_uids: string,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/paid',
    {
      method: 'DELETE',
      params: {
        series_uids,
      },
    },
    options
  );
  return response.data;
}
